export default {
  // system
  'Cookies are not enabled in current environment.':
    'Cookies are not enabled in current environment. Please enable all Cookies and try again.',
  'Are you sure you want to delete {value} ?':
    'Are you sure you want to delete {value} ?',
  // general
  Ok: 'OK',
  Okay: 'OK',
  Success: 'Success',
  // discover
  discoverTitle: 'Discover your next destination',
  DiscoverCTA: 'Funliday makes trip planning easier',
  '{value} travelers are planning trips':
    '{value} travelers are planning trips',
  Discover: 'Discover',
  destination: 'Destination',
  days: '{count, plural, =0 {# Day} =1 {# Day} other {# Days}}',
  read: 'read',
  likes: 'likes',
  sponsor: 'Sponsor',
  Featured: 'Featured',
  'No journals found.': 'No journals found.',
  shares: 'shares',
  Copied: 'Copied',
  Tweet: 'Tweet',
  Post: 'Post',
  Comments: 'Comments',
  Reply: 'Reply',
  'Leave a comment…': 'Leave a comment…',
  'View more reply': 'View more reply',
  'Top Itinerary': 'Top Itinerary',
  'Top Attraction': 'Top Attraction',
  'Top Journal': 'Top Journal',
  'Top Destination': '熱門目的地',
  'Latest Journal': 'Latest Journal',
  'Travel Guru': 'Travel Guru',
  All: 'All',
  Journals: 'Journals',
  Itineraries: 'Itineraries',
  'Read the post': 'Read the post',
  'Discover search results':
    'Found {value1} items at least, including {value2}',
  'Discover search title': 'Search {title}',
  DiscoverProductDirectory_Experiences: 'Experiences',
  DiscoverProductDirectory_Car: 'Car Rental',
  DiscoverProductDirectory_Hotels: 'Hotels',
  DiscoverProductDirectory_SimWifi: 'Wifi/SIM Cards',
  DiscoverProductDirectory_Agent: 'Japan Shopping Service',

  // journals
  'This is a private journal.': 'This is a private journal.',
  'Just now': 'Just now',
  '{value} day ': '{value} day',
  '{value} days ': '{value} days',
  '{value} month ': '{value} month',
  '{value} months ': '{value} months',
  '{value} year ': '{value} year',
  '{value} years ': '{value} years',

  // Collections
  'Copy Attractions': 'Copy Attractions',
  'Name of the collection folder': 'Name of the collection folder',
  'Please input name of the collection folder':
    'Please input name of the collection folder',
  'No attractions have been added yet.': 'No attractions have been added yet.',
  'Create a new folder': 'Create a new folder',
  'Name of folder': 'Name of folder',
  Move: 'Move',
  'No more folders': 'No more folders',
  'Move to...': 'Move to...',
  'Copy to...': 'Copy to...',
  'Do you want to move collections to {value} ?':
    'Do you want to move collections to {value} ?',
  'Do you want to copy collections to {value} ?':
    'Do you want to copy collections to {value} ?',
  'Update folder info': 'Update folder info',

  // privacy setting
  'Privacy setting': 'Privacy setting',
  'Only You can access this collections folder. If you want to share the collections folder to the social network, please change it to "Public" or "Share by link".':
    'Only You can access this collections folder. If you want to share the collections folder to the social network, please change it to "Public" or "Share by link".',

  // profile
  Overview: 'Overview',
  Profile: 'Profile',
  journals: 'Journals',
  Likes: 'Likes',
  RecommendedTrips: 'Trips',
  RecommendedCollections: 'RecommendedCollections',
  RelatedJournals: 'Journals',
  'No trips found.': 'No trips found.',
  'No public trips found.': 'No public trips found.',
  'No public photos found.': 'No public photos found.',
  'No public description found.': 'No public description found.',
  'No public information found.': 'No public information found.',
  Photos: 'Photos',
  'Travel Suggestions': 'Travel Suggestions',
  'Switch Account': 'Switch Account',
  Hostels: 'Hostels',
  Members: 'Members',
  'Who to follow': 'Who to follow',
  'Change profile picture': 'Change profile picture',

  // itinerary
  'Someone is editing the trip, please reload this page to get the latest itinerary.':
    'Someone is editing the trip, please reload this page to get the latest itinerary.',
  'Your edit session has expired. Please reload the page to continue.':
    'Your edit session has expired. Please reload the page to continue.',
  Reload: 'Reload',
  day: 'Day {index}',
  hr: 'hr',
  min: 'min',
  '{value} hr ': '{value} hr ',
  '{value} hrs ': '{value} hrs ',
  '{value} min ': '{value} min ',
  '{value} mins ': '{value} mins ',
  '{value} hour ': '{value} hour ',
  '{value} hours ': '{value} hours ',
  '{value} minute ': '{value} minute ',
  '{value} minutes ': '{value} minutes ',
  sec: '{value}s ',
  secs: '{value}s ',
  seconds: 'seconds',
  '{value} second': '{value} second',
  '{value} seconds': '{value} seconds',
  formattedDirectionTime: 'take {value} to get there',
  customDirectionTime: 'you set {value} to get there',
  'directions not available': 'directions not available',
  startTime: 'Start Time : ',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  From: 'From',
  To: 'To',
  km: 'km',
  kms: 'km',
  meter: 'meter',
  meters: 'meters',
  mile: 'mile',
  miles: 'miles',
  'Stay for': 'Stay for {value}',
  'and departure at': 'and departure at {value}',
  stop: '{value} stop',
  stops: '{value} stops',
  'Oops! Connection error...': 'Oops! Connection error...',
  'try again': 'try again',
  Attraction: 'Attraction',
  'Text Note': 'Note',
  '24 hours a day': '24 hours a day',
  'This is a private itinerary.': 'This is a private itinerary.',
  'Show map': 'Show map',
  'Show itinerary': 'Show itinerary',
  'Connection error': 'Connection error',
  Edit: 'Edit',
  'You are currently in edit mode': 'You are currently in edit mode',
  'Please use App to edit the itinerary':
    'Please use App to edit the itinerary',
  'Alternative name for attraction': 'Alternative name for attraction',
  '+ Add new attraction': '+ Add new attraction',
  '+ Add a flight': '+ Add a flight',
  'Invalid trip name': 'Invalid trip name',
  Search: 'Search',
  Custom: 'Custom',
  "You don't have permission to do this":
    "You don't have permission to do this",
  'Create a New Attraction': 'Create a New Attraction',
  'Name of attraction': 'Name of attraction',
  Address: 'Address',
  'Phone#': 'Phone#',
  Website: 'Website',
  'Mandatory fields': 'Mandatory fields',
  'Please fill in City, State or district':
    'Please fill in City, State or district',
  'Keyword of attraction': 'Keyword of attraction',
  "Please set 'City' field for search an attraction more precisely.":
    "Please set 'City' field for search an attraction more precisely.",
  more: 'more',
  'Add to itinerary': 'Add to itinerary',
  'Added to itinerary': 'Added to itinerary',
  'Add to collections': 'Add to collections',
  'Added to collections': 'Added to collections',
  'If you want to edit the itinerary, please click edit button on the upper right corner to enter edit mode.':
    'If you want to edit the itinerary, please click edit button on the upper right corner to enter edit mode.',
  'Please input name & address': 'Please input name & address',
  'Please check format of website url': 'Please check format of website url',
  AM: 'AM',
  PM: 'PM',
  'Stay time': 'Stay time',
  'Which city are you searching?': 'Which city are you searching?',
  'You don’t have any collections': 'You don’t have any collections',
  'Get the route on the mobile app.': 'Get the route on the mobile app.',
  'Get detailed route on Funliday App': 'Get detailed route on Funliday App',
  'Permanently closed': 'Permanently closed',
  'Accurate search': 'Accurate search',
  poiNotFound: 'There are no「{keyword}」found in the {cityName}.',
  'AccurateSearchQRCode.Title':
    'Try out the accurate search by scan QR code on Funliday mobile app!',
  Departure: 'Departure',
  'Add flight on the mobile app by scan QRcode.':
    'Add flight on the mobile app by scan QRcode.',
  Arrival: 'Arrival',
  'Embed a map': 'Embed a map',
  'Copy HTML': 'Copy HTML',
  'Before you embed an itinerary map, please change the privacy of the itinerary to "Share by link" or "Public" so that others can view your itinerary.':
    'Before you embed an itinerary map, please change the privacy of the itinerary to "Share by link" or "Public" so that others can view your itinerary.',
  Next: 'Next',
  Hot: 'Hot',
  'Privacy and share': 'Privacy and share',
  'There is no editable trip': 'There is no editable trip',
  'Are you sure you want to remove {item}':
    'Are you sure you want to remove {item}?',
  'Funliday Plan trips • Share memories':
    'Funliday Plan trips • Share memories',
  'Long press and drag here to sort the attraction':
    '⬅️ Long press and drag here to sort the attraction',
  'Copy itinerary to easily plan your next trip':
    'Copy itinerary to easily plan your next trip',
  'Do not show again': 'Do not show again',
  'Got it!': 'Got it!',

  // date
  today: 'today',
  shortSunday: 'Sun',
  shortMonday: 'Mon',
  shortTuesday: 'Tue',
  shortWednesday: 'Wed',
  shortThursday: 'Thu',
  shortFriday: 'Fri',
  shortSaturday: 'Sat',

  // login
  'Sign in with Facebook': 'Sign in with Facebook',
  'Sign in with Google': 'Sign in with Google',
  'Sign in with Yahoo!': 'Sign in with Yahoo!',
  'Sign in with Twitter': 'Sign in with Twitter',
  'Sign in with Apple': 'Sign in with Apple',
  'Sign in': 'Sign in',
  'Sign out': 'Sign out',
  'Sign in fail, please try again.': 'Sign in fail, please try again.',
  'Hi,': 'Hi,',
  EMAIL: 'EMAIL',
  'Please enter your email.': 'Please enter your email.',
  'Set profile picture and nickname': 'Set profile picture and nickname',
  'Can be changed at any time.': 'Can be changed at any time.',
  'Nickname cannot be empty.': 'Nickname cannot be empty.',
  'Get Started': 'Get Started',
  Skip: 'Skip',
  'By clicking sign in, you agree to our <a>User Agreement</a>':
    'By clicking sign in, you agree to our <a>User Agreement</a>',
  or: 'or',
  'Please enter your email registered on Facebook':
    'Please enter your email registered on Facebook',
  'Please enter your email registered on {provider}':
    'Please enter your email registered on {provider}',
  'If you are new to Funliday, please using Google or Apple sign in.':
    'If you are new to Funliday, please using Google or Apple sign in.',
  'Verification failed. Please enter your email again.':
    'Verification failed. Please enter your email again.',
  'Please enter verification code': 'Please enter verification code',
  'A verification code has been sent to "{email}", please enter verification code below.':
    'A verification code has been sent to "{email}", please enter verification code below.',
  'Verification code': 'Verification code',
  'Verification failed. Please enter again.':
    'Verification failed. Please enter again.',
  'A valid email address is required to register.':
    'A valid email address is required to register.',

  // segment
  Trips: 'Trips',
  Collections: 'Collections',
  Invitations: 'Invitations',
  'My Trips': 'My Trips',
  'Travel Groups': 'Travel Groups',
  'My Collections': 'My Collections',
  'My collections': 'My collections',
  'My Collections Folders': 'My Collections Folders',
  'Groups Collections': 'Groups collections',

  // my trips
  'Loading...': 'Loading...',
  'Privacy of the itinerary': 'Privacy of the itinerary',
  Done: 'Done',
  Cancel: 'Cancel',
  Yes: 'Yes',
  PUBLIC: 'Public',
  'Anyone on the Internet can find and access.':
    'Anyone on the Internet can find and access.',
  'Share by link': 'Share by link',
  'Anyone who has the link can access.': 'Anyone who has the link can access.',
  PRIVATE: 'Private',
  'Only You and members of the travel group who can see or access this itinerary and you must be logged in to do it. If you want to share the itinerary to social network, please change it to Public or Share by link.':
    'Only You and members of the travel group who can see or access this itinerary and you must be logged in to do it. If you want to share the itinerary to social network, please change it to Public or Share by link.',
  'Connection error, please try again.': 'Connection error, please try again.',
  'This web page is in beta version. If you want to create a trip. Please use Mobile App to access full function of Funliday.':
    'This web page is in beta version. If you want to create a trip. Please use Mobile App to access full function of Funliday.',
  "Oops, you don't have any travel group that invited by others!":
    "Oops, you don't have any travel group that invited by others!",
  'A new trip': 'A new trip',
  'Start date': 'Start date',
  'End date': 'End date',
  DayCount: 'Day',
  DayCounts: 'Days',
  Days: 'Days',
  'Name of the trip': 'Name of the trip',
  'New trip': 'New Trip',
  'Please input name of the trip': 'Please input name of trip',
  'Please input days': 'Please input days',
  'Please choose a start date': 'Please choose a start date',
  'Share with others': 'Share with others',
  'Send a copy to friends': 'Send a copy to friends',
  Delete: 'Delete',
  'Welcome to Funliday, Please click + button to create a new trip! Have a nice vacation.':
    'Welcome to Funliday, Please click + button to create a new trip! Have a nice vacation.',
  Leave: 'Leave',
  'Travel group': 'Travel group',
  Close: 'Close',
  'Invite friends to edit or view this trip':
    'Invite friends to edit or view this trip',
  'Invite friends by link': 'Invite friends by link',
  'Search by email': 'Search by email',
  'Search results': 'Search results',
  'Recommended list': 'Recommended list',
  Add: 'Add',
  Pending: 'Pending',
  'Can view': 'Can view',
  'Can edit': 'Can edit',
  'Invite to trip': 'Invite to trip',
  'Anyone with link can join as trip member':
    'Anyone with link can join as trip member',
  'Travel dates': 'Travel dates',

  // `title` attribute
  'Delete day': 'Delete day',
  'Copy attraction': 'Copy attraction',
  'Delete attraction': 'Delete attraction',

  // Invitations
  "Oops, you don't have any invitations!":
    "Oops, you don't have any invitations!",
  '{value} invited you to join the travel group':
    '{value} invited you to join the travel group',
  '{value1} sent an itinerary to you, Do you want to add「{value2}」to my trips?':
    '{value1} sent an itinerary to you, Do you want to add「{value2}」to my trips?',
  'This trip has been added to "My Trips"':
    'This trip has been added to "My Trips"',
  'This trip has been added to "Travel Groups"':
    'This trip has been added to "Travel Groups"',
  'invited you to join the travel group':
    'invited you to join the travel group',
  'This invitation has expired.':
    'This invitation has expired. Please ask inviter to generate an invitation link again.',
  'You have joined this travel group.': 'You have joined this travel group.',
  'You have declined to join this travel group.':
    'You have declined to join this travel group.',
  Accept: 'Accept',
  Decline: 'Decline',
  'Back to Homepage': 'Back to Homepage',
  Homepage: 'Homepage',
  'Download Funliday App': 'Download Funliday App',
  'Open Itinerary': 'Open Itinerary',
  'Open Journal': 'Open Journal',
  // landing pages (download app pages)
  'Best Travel Planning App': 'Best Travel Planning App',
  'Plan trips, Share memories': 'Plan trips • Share memories',
  'What is Funliday?': 'What is Funliday?',
  'Funliday description':
    'Funliday is a trip planning app that makes your trip easier, helps you to manage your trips, find local attractions, and get directions. We support iOS, Android and desktop platforms. Funliday providers thousands of destinations, you can easily explore all of the places you are interested in and simply add them to your itinerary. You can also organize schedules and routes, as well as access all other useful information for your trip.',
  'Download App': 'Download App',
  'Download Funliday': 'Download Funliday',
  'Plan a trip': 'Plan a trip',
  'Web version': 'Web version',
  'Explore places': 'Explore places',
  'Explore attractions in both list mode and map mode.':
    'Explore attractions in both list mode and map mode.',
  'Search attractions all over the world.':
    'Search attractions all over the world.',
  'Easy to organize your trip': 'Easy to organize your trip',
  'Schedule your trip easily.': 'Schedule your trip easily.',
  'Long press and drag to organize your trip.':
    'Long press and drag to organize your trip.',
  'Get direction automatically.': 'Get direction automatically.',
  'Edit trip together with others': 'Edit trip together with others',
  'Now you can share your trip and edit trip with you friends.':
    'Now you can share your trip and edit trip with you friends.',
  'Send a copy of trip itinerary to friends as well.':
    'Send a copy of trip itinerary to friends as well.',
  'Available for ios and android platforms.':
    'Available for iOS and Android platforms.',
  'Support offline mode': 'Support offline mode',
  'Turn to offline mode when you lose connection.':
    'Turn to offline mode when you lose connection.',
  'View whole trip info even in offline mode.':
    'View whole trip info even in offline mode.',
  'Funliday for iPhone/Android': 'Funliday for iPhone/Android',
  'Sync all your itineraries from anywhere.':
    'Sync all your itineraries from anywhere.',
  'CONTACT US': 'CONTACT US',
  'Google form': 'https://goo.gl/HwVedY',
  Tutorial: 'Tutorial',

  // qr Code
  'How to use Funliday QR Code?': 'How to use Funliday QR Code?',
  'Get accurate search result on Funliday App':
    'Get accurate search result on Funliday App',
  'How to use?': 'How to use?',
  'Copy itinerary': 'Copy itinerary',
  'Search attractions': 'Search attractions',
  'Get directions': 'Get directions',
  Step1: 'Step 1',
  Step2: 'Step 2',
  Step3: 'Step 3',
  Step4: 'Step 4',
  Step5: 'Step 5',
  Step6: 'Step 6',
  Step7: 'Step 7',
  'Step1 Description':
    'Please download Funliday on the App Store or Google Play.',
  'Step2 Description': 'Sign in by Facebook or Google account.',
  'Step3 Description': 'Click "QR Code" in the "More" page.',
  'Itinerary Step4 Description': "Scann a QR Code on a blog's post.",
  'Itinerary Step5 Description':
    'You can see the itinerary info after scanning success.',
  'Itinerary Step6 Description':
    'YA! You already copy an itinerary to your Funliday account.',

  'Attraction Step4 Description':
    'Scan a QR Code in the search attraction page on the desktop',
  'Attraction Step5 Description':
    'You can see the search results on the phone after scanning success',
  'Attraction Step6 Description':
    'Select an attraction which you want to add into the itinerary',
  'Attraction Step7 Description':
    'After added the attraction, your itinerary will be synced on every device',

  'Direction Step4 Description':
    'Scan a QR Code in the direction page on the desktop',
  'Direction Step5 Description':
    'You can get the direction details on the phone after scanning success',
  'Direction Step6 Description':
    'The direction details will be synced on every device',

  // menu
  'Cathay Pacific Promo Code': 'Cathay Pacific Promo Code',
  QRcode: 'QRcode',
  'Press Kit': 'PRESS KIT',
  'Contact Us': 'Contact Us',
  'Open in App': 'Open in App',
  Notifications: 'Notifications',

  // route
  Options: 'Options',
  'Customize timetable': 'Customize timetable',

  // transit mode
  'Preferred Modes': 'Preferred Modes',
  Bus: 'Bus',
  Metro: 'Metro',
  Train: 'Train',
  Tram: 'Tram',
  'Transit routing preference': 'Transit routing preference',
  'Best route': 'Best route',
  'Fewer transfers': 'Fewer transfers',
  'Less walking': 'Less walking',

  // driving restriction
  'Restrictions preference': 'Restrictions preference',
  'Avoid highways': 'Avoid highways',
  'Avoid tolls': 'Avoid tolls',
  'Avoid ferries': 'Avoid ferries',

  // personal
  'Login by': 'Login by',
  'User ID': 'User ID',
  Nickname: 'Nickname',
  Bio: 'Bio',
  'User ID only allowed one-time change.':
    'User ID only allowed one-time change.',
  '{value} has already been taken.': '{value} has already been taken.',
  'The first character must be a lowercase letter.':
    'The first character must be a lowercase letter.',
  'Only letters, digits, "_" and "." are allowed.':
    'Only letters, digits, "_" and "." are allowed.',
  'The last character must be a lowercase letter or digit.':
    'The last character must be a lowercase letter or digit.',
  'The Payor and Lessee shall be the same individual or party':
    'The Payor and Lessee shall be the same individual or party',
  'User ID must be minimum 3 and maximum 20 characters.':
    'User ID must be minimum 3 and maximum 20 characters.',
  'Nickname must be maximum 20 characters.':
    'Nickname must be maximum 20 characters.',
  Required: 'Required',
  Save: 'Save',
  'Edit user ID': 'Edit user ID',
  'Edit nickname': 'Edit nickname',
  Settings: 'Settings',

  // onboarding
  'You can easily plan a trip by picking the destination and date.':
    'You can easily plan a trip by picking the destination and date.',
  'Discover next destination': 'Discover next destination',
  'Select an itinerary template': 'Select an itinerary template',
  'Power by': 'Power by',
  'Build an itinerary': 'Build an itinerary',
  Back: 'Back',
  'Popular trip templates': 'Popular trip templates',

  // Hack:
  五一連假熱門景點預測: '五一連假熱門景點預測',
  旅宿數位轉型計畫: '旅宿數位轉型計畫',

  // cart
  Bookings: 'Bookings',
  'Add to trip': 'Add to trip',
  'Added to trip': 'Added to trip',
  Paid: 'Paid',
  'Payment Failed': 'Payment Failed',
  Refunding: 'Refunding',
  Refunded: 'Refunded',
  'Card Error': 'Card Error',
  'Bank System Error': 'Bank System Error',
  'Duplicate Transaction': 'Duplicate Transaction',
  'Bank Merchant Account Data Error': 'Bank Merchant Account Data Error',
  'Amount Error': 'Amount Error',
  'Order number duplicate': 'Order number duplicate',
  'Bank Error': 'Bank Error',
  'Redeem Failed': 'Redeem Failed',
  'Payment processing': 'Payment processing',

  'Booking Confirmed': 'Booking Confirmed',
  'Booking Pending': 'Booking Pending',
  'Booking Cancelled': 'Booking Cancelled',
  Completed: 'Completed',
  'Booking Details': 'Booking Details',
  'Booking no.': 'Booking no.',
  'Product Details': 'Product Details',
  'Payment Status': 'Payment Status',
  'Booking Status': 'Booking Status',
  Date: 'Date',
  Session: 'Session',
  Quantity: 'Quantity',
  Name: 'Name',
  Surname: 'Surname',
  'Given Names': 'Given Names',
  Email: 'Email',
  'Contact No.': 'Contact No.',
  'Traveller Details': 'Traveller Details',
  Nationality: 'Nationality',
  'Foreign Traveler': 'Foreign Traveler',
  'Passport No./ Taiwan ID No.': 'Passport No./ Taiwan ID No.',
  'Passport No.': 'Passport No.',
  'ID No.': 'ID No.',
  'Date of Birth': 'Date of Birth',
  Gender: 'Gender',
  GENDER_M: 'Male',
  GENDER_F: 'Female',
  GENDER_X: 'Prefer not to say',
  'Your booking is still being confirmed. In order to ensure the safety of passengers, the itinerary will be covered by travel insurance. Please provide the passenger information below.':
    'Your booking is still being confirmed. In order to ensure the safety of passengers, the itinerary will be covered by travel insurance. Please provide the passenger information below.',
  Update: 'Update',
  placeholderName: 'e.g.: John Smith',
  placeholderNameFirst: 'e.g.: JOHN',
  placeholderNameLast: 'e.g.: SMITH',
  placeholderNationality: 'e.g.: TWN',
  'MM/DD/YYYY': 'MM/DD/YYYY',
  'Share the booking details with group':
    'Share the booking details with group',
  'Minimum number of guests required:': 'Minimum number of guests required:',
  'Availability:': 'Availability:',
  'Book Now': 'Book Now',
  'Sold Out': 'Sold Out',
  'Up to {value} can be purchased at a time':
    'Up to {value} can be purchased at a time',
  'I have read, understood and accepted the {value}.':
    'I have read, understood and accepted the {value}.',
  'Payment Method': 'Payment Method',
  'Select a date': 'Select a date',
  Payment: 'Payment',
  'Credit Card Payment': 'Credit Card Payment',
  'Credit Card': 'Credit Card',
  'Card No.': 'Card No.',
  'EXP. Date': 'EXP. Date',
  CVV: 'CVV',
  'Save this credit card.': 'Save this credit card.',
  'Add New Credit Card': 'Add New Credit Card',
  'Make a payment': 'Make a payment',
  'Payment completed.': 'Payment completed.',
  'Booking confirmed.': 'Booking confirmed.',
  'Your booking is being confirmed.': 'Your booking is being confirmed.',
  'Local Tour': 'Local Tour',
  'Gathering time': 'Gathering time',
  'There are no bookings in this itinerary.':
    'There are no bookings in this itinerary.',
  'Import bookings': 'Import bookings',
  Total: 'Total',
  Subtotal: 'Subtotal',
  'VAT Number': 'VAT Number',
  Recipient: 'Recipient',
  'Country/Region': 'Country/Region',
  City: 'City',
  'Zip Code': 'Zip Code',
  'The goods will be sent by the supplier, please fill in the recipient information.':
    'The goods will be sent by the supplier, please fill in the recipient information.',
  Orders: 'Orders',
  'My bookings': 'My bookings',
  'This tour is provided by {value}': 'This tour is provided by {value}',
  'Your booking information has been received, thank you for booking the products on Funliday!':
    'Your booking information has been received, thank you for booking the products on Funliday!',
  'Your booking information has been received':
    'Your booking information has been received',
  'Your booking information has been updated':
    'Your booking information has been updated',
  Notice: 'Notice',
  'Cancellation policy': 'Cancellation policy',
  'Customer service': 'Customer service',
  'Please select': 'Please select',
  'Please check your entry': 'Please check your entry',
  'Please choose a date': 'Please choose a date',
  'Please choose a session': 'Please choose a session',
  'Please choose the quantity of item': 'Please choose the quantity of item',
  'Please fill in name': 'Please fill in name',
  'Please fill in email': 'Please fill in email',
  'Please fill in phone number': 'Please fill in phone number',
  'Please agree with the %1$s': 'Please agree with the %1$s',
  'Incorrect email format': 'Incorrect email format',
  'Incorrect phone number': 'Incorrect phone number',
  'Please choose a payment method': 'Please choose a payment method',
  'Please choose a credit card': 'Please choose a credit card',
  'Please fill in CVV': 'Please fill in CVV',
  'Please fill in the credit card expiration date':
    'Please fill in the credit card expiration date',
  'Please fill in the credit card number':
    'Please fill in the credit card number',
  'This card number is not valid': 'This card number is not valid',
  'This expiration date is not valid': 'This expiration date is not valid',
  'This CVV is not valid': 'This CVV is not valid',
  'This card is not valid': 'This card is not valid',
  'Authorization failed, transaction cancelled':
    'Authorization failed, transaction cancelled',
  'Do you want to remove this credit card?':
    'Do you want to remove this credit card?',
  'Payment has been completed, if you want to view the order details, please go to Bookings page':
    'Payment has been completed, if you want to view the order details, please go to Bookings page',
  'No bookings yet': 'No bookings yet',
  'Credit card removal failed, please try again later':
    'Credit card removal failed, please try again later',
  'Invalid date of birth': 'Invalid date of birth',
  'Invalid Passport No./ Taiwan ID No.': 'Invalid Passport No./ Taiwan ID No.',
  'Invalid Passport No.': 'Invalid Passport No.',
  'Invalid ID No.': 'Invalid ID No.',
  'Invalid Input': 'Invalid Input',
  'Your booking information has been updated.(Booking NO.: %1$s)':
    'Your booking information has been updated.(Booking NO.: %1$s)',

  'Currently unavailable': 'Currently unavailable',
  'No longer sold': 'No longer sold',
  "Oops, you don't have any bookings yet.":
    "Oops, you don't have any bookings yet.",
  'Inventory shortage': 'Inventory shortage',
  'Oops...This product is sold out': 'Oops...This product is sold out',
  'Oops...Inventory shortage': 'Oops...Inventory shortage',
  'Oops...This product is no longer sold':
    'Oops...This product is no longer sold',
  'This product is currently unavailable':
    'This product is currently unavailable',
  'Coming soon': 'Coming soon',

  'Select a Credit Card': 'Select a Credit Card',
  'The minimum quantity of this item is {value}':
    'The minimum quantity of this item is {value}',
  Additional: 'Additional',
  Remarks: 'Remarks',
  'Please fill in the remarks.': 'Please fill in the remarks.',
  'Please fill in the {value}': 'Please fill in the {value}.',

  // Experiences
  // Experiences: 'Experiences',
  Experiences: 'Tickets & Tours',
  'Find unique local experiences': 'Find unique local experiences',

  Taiwan: 'Taiwan',
  Japan: 'Japan',
  Global: 'Global',
  正體中文: '正體中文',
  日本語: '日本語',
  English: 'English',

  Products: 'Products',
  'More products': 'More products',
  'No products yet': 'No products yet',
  'product already added': 'product already added',
  'Add attraction from bookings': 'Add attraction from bookings',
  'Delete from trip': 'Delete from trip',
  Expand: 'Expand',
  Collapse: 'Collapse',
  'Recommended stay time: {hrs} hrs {mins} mins':
    'Recommended stay time: {hrs} hrs {mins} mins',
  '{hrs} hrs {mins} mins': '{hrs} hrs {mins} mins',
  'Update your browser for the best experience':
    'Update your browser for the best experience',
  "For instructions on how to upgrade, visit your browser's help resources:":
    "For instructions on how to upgrade, visit your browser's help resources:",
  'Copy URL': 'Copy URL',
  Voucher: 'Voucher',
  'Redeem code - Processing': 'Redeem code - Processing',
  admission: 'admission',
  '{value} km away': '{value} km away',
  fans: 'fans',
  following: 'following',
  follow: 'follow',
  'You aren’t following anyone yet': 'You aren’t following anyone yet',
  'You don’t have any fans yet': 'You don’t have any fans yet',
  '{value1} likes your {value2}': '{value1} likes your {value2}',
  '{value} is following you': '{value} is following you',
  '{value1} has posted a journal: {value2}':
    '{value1} has posted a journal: {value2}',

  "This Page Isn't Available": "This Page Isn't Available",
  "The link may be broken, or the page may have been removed. Check to see if the link you're trying to open is correct.":
    "The link may be broken, or the page may have been removed. Check to see if the link you're trying to open is correct.",
  // my journals
  Published: 'Published',
  Publish: 'Publish',
  Drafts: 'Drafts',
  'New journal': 'New journal',
  'No more journals': 'No more journals',
  'No more draft': 'No more draft',
  'Write a journal for an itinerary': 'Write a journal for an itinerary',
  Title: 'Title',
  'Saving...': 'Saving...',
  Saved: 'Saved',
  'Save failed': 'Save failed',
  Description: 'Description',
  'Change cover photo': 'Change cover photo',
  'Add photos': 'Add photos',
  'Write a caption': 'Write a caption',
  'Hide this attraction': 'Hide this attraction',
  'Show this attraction': 'Show this attraction',
  'Hide the day': 'Hide the day',
  'Show the day': 'Show the day',
  Retry: 'Retry',
  Uploading: 'Uploading',
  'Upload failed': 'Upload failed',
  'Please fill in title of the travel journal.':
    'Please fill in title of the travel journal.',
  'Please fill in description of the travel journal.':
    'Please fill in description of the travel journal.',
  'The limit is {max} photos for each attraction.':
    'The limit is {max} photos for each attraction.',
  Privacy: 'Privacy',
  'Share on Facebook': 'Share on Facebook',
  'Do you want to discard the changes?': 'Do you want to discard the changes?',
  'There are no attractions for this journal. Please add an attraction first.':
    'There are no attractions for this journal. Please add an attraction first.',
  'Edit itinerary': 'Edit itinerary',
  'Please select an image for cover of the travel journal.':
    'Please select an image for cover of the travel journal.',
  Share: 'Share',
  // car rental
  'Car rental': 'Car rental',
  'Pick-up location': 'Pick-up location',
  '{value}{unit} OFF': '{value}{unit} OFF',
  'From {unit} {price}': 'From {unit} {price}',
  'From {unit} {price}/day': 'From {unit} {price}/day',
  '{count} seats': '{count} seats',
  '{count} luggage': '{count} luggage',
  'Book on Funliday App': 'Book on Funliday App',
  'Booking Period': 'Booking Period',
  'Drop-off Depot': 'Drop-off Location',
  'Drop-off Time': 'Drop-off Time',
  'Drop-off Time Car': 'Drop-off Time',
  'Drop-off Time: {date}\nRent for up to 15 days':
    'Drop-off Time: Before {date}\nRent for up to 15 days',
  'Before {date}': 'Before {date}',
  'Pick-up Depot': 'Pick-up Location',
  'Pick-up Options': 'Pick-up/ Delivery',
  'Pick-up Time': 'Pick-up Time',
  'Pick-up Time Car': 'Pick-up Time',
  'No matches were found for your search criteria.':
    'No matches were found for your search criteria.',
  'Showing results for {criteria}.': 'Showing results for {criteria}.',
  '{departure} ~ {arrival}, {seat} seats, {luggage} luggage':
    '{departure} ~ {arrival}, {seat} seats, {luggage} luggage',
  // sim/ wifi rental
  'Sim-Wifi': 'Data Sim/ Wifi',
  'Drop-off Location': 'Drop-off Location',
  'Pick-up Location': 'Pick-up Location',
  'Pick-up Counter': 'Pick-up Counter',
  'Pick-up Time Wifi': 'Pick-up Time',
  'Drop-off Time Wifi': 'Drop-off Time',

  'Official Blog': 'Official Blog',
  // about
  'About Us': 'About Us',
  Slogan:
    'The analysis of tourism information should not be {pastEN} but {futureEN}.',
  Mission:
    'Make it easier for everyone to plan their trips and share experiences.',
  'Mission details':
    "Since its establishment in 2017, Funliday has been committed to solving travelers' various problems before, during, and after the trip. Through analyzing the future big data provide travelers with better travel planning and experience sharing, make travel planning and experience sharing effortless, while matching travelers' interests and local sightseeing characteristics, and help countries effectively promote inbound tourism.",
  aboutMembers: 'Members',
  aboutItineraries: 'User-built itineraries',
  'Global attractions, support 12 languages':
    'Global attractions in 12 languages',
  Founder: 'Founder',
  'Willie Huang': 'Willie Huang',
  'Founder quote':
    'Why does it take so much time to compile information when arranging self-guided tour? If every attraction, ticket, and itinerary is a building block, people can make up their journey with more flexibility and ease. My goal is to get out flexibly and freely and do things like playing with building blocks. There are two million user-built itineraries have been accumulated on Funliday. We have information such as when users travel, where to go, how to get there, what attractions to visit, whom to go with, and can provide detailed travel behavior data for each region to help it offer better tourism quality and generate more revenue.',
  Team: 'Team',
  'Chief Technology Officer': 'Chief Technology Officer',
  'Chief Product Officer': 'Chief Product Officer',
  'Software Engineer': 'Software Engineer',
  'Senior Business Development Manager': 'Senior Business Development Manager',
  Partners: 'Partners',
  'Company Info': 'Company Info',
  'Company Name': 'Company Name',
  'Funliday, Inc.': 'Funliday, Inc.',
  'Date of Establishment': 'Date of Establishment',
  'March 15, 2017': 'March 15, 2017',
  Capital: 'Capital',
  'NTD 2,960,000': 'NTD 2,960,000',
  '5F.-8, No. 16, Sec. 1, Nanjing E. Rd., Zhongshan Dist., Taipei City 104 , Taiwan':
    '5F.-8, No. 16, Sec. 1, Nanjing E. Rd., Zhongshan Dist., Taipei City 104 , Taiwan',
  'Leave a comment': 'Leave a comment',
  Submit: 'Submit',
  // Referral
  Referral: 'Referral',
  'Invitation code': 'Invitation code',
  'Referral link': 'Referral link',
  'Did not win any prize': 'Did not win any prize',
  'Won a prize': 'Won a prize',
  'Announcement: {date}': 'Announcement: {date}',
  'Not yet started': 'Not yet started',
  '{N}lucky draw chances': '{N}lucky draw chances',
  'Get a chance to win the Regent Hotel voucher by entering the invitation code. (Taiwan only)':
    'Get a chance to win the Regent Hotel voucher by entering the invitation code. (Taiwan only)',
  'Rules of participation': 'Rules of participation',
  'Invalid invitation code': 'Invalid invitation code',
  'Start date: {date}': 'Start date: {date}',
  'Share to': 'Share to',

  // planner tool
  'Create a new trip': 'Create a new trip',
  'Start your trip planning by adding the attractions you want to go.':
    'Start your trip planning by adding the attractions you want to go.',
  'Trip planner': 'Trip planner',
  'Save itinerary': 'Save itinerary',
  'Save to cloud': 'Save to cloud',
  'Download PDF': 'Download PDF',
  'This service is provided by {Funliday}':
    'This service is provided by {Funliday}',
  'Please fill in your email and we will send the itinerary PDF file to your mailbox.':
    'Please fill in your email and we will send the itinerary PDF file to your mailbox.',
  'The itinerary has been sent to your mailbox':
    'The itinerary has been sent to your mailbox',
  'Added to the trip successfully!': 'Added to the trip successfully!',
  'Log in to Funliday to sync your itineraries and collections to other devices.':
    'Log in to Funliday to sync your itineraries and collections to other devices.',
  'Start your attractions collecting by collect the attractions.':
    'Start your attractions collecting by collect the attractions.',

  // Footer
  'Follow Us': 'Follow Us',

  dayjs: {
    name: 'en-funliday',
    weekdays: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    monthsShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    formats: {
      LT: 'h:mm A',
      LTS: 'h:mm:ss A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
      l: 'M/D/YYYY',
      ll: 'MMM D',
      lll: 'MMM D, YYYY h:mm A',
      llll: 'ddd, MMM D, YYYY h:mm A'
    },
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    }
  },

  // City Guide
  'City Guide': 'City Guide',
  cityGuideTitle: 'Guide | Funliday Plan trips • Share memories',
  cityGuideDescription:
    'guide includes the recommended attractions, travel experiences, must-visits, attractions popular on social media, and must-eats restaurants.',
  cityGuideTopic:
    'Discover your next destination | Funliday - Plan trips • Share memories',
  linkFacebook: 'https://www.facebook.com/funliday',
  linkInstagram: 'https://www.instagram.com/funliday.tw/',

  // Reward Points
  REWARD_POINTS_CTA:
    'Start to earn Fun Points today and save up to 5% upon purchase',
  'My Fun Points Summary': 'My Fun Points Summary',
  '{value} points will expire on {date}':
    '{value} points will expire on {date}',
  'No Fun Points history found': 'No Fun Points history found',
  'Redeem Points': 'Redeem Points',
  'Apply {value}': 'Apply {value}',
  'Points Applied': 'Points Applied'
};
